<template>
  <RouterLink target="_blank" :to="path" class="sh-more">
    <span>查看更多</span>
    <i class="iconfont icon-youbian"></i>
  </RouterLink>
</template>

<script>
export default {
  name: "ShMore",
  //接受传递参数以指向跳转不同的链接
  props: {
    path: {
      type: String,
      default: "/",
    },
  },
};
</script>

<style scoped lang="less">
.sh-more {
  margin-bottom: 2px;
  margin-left: 15px;
  span {
    font-size: 16px;
    vertical-align: middle;
    margin-right: 4px;
    color: #999;
  }
  i {
    font-size: 14px;
    vertical-align: middle;
    position: relative;
    top: 2px;
    color: #ccc;
  }
  &:hover {
    span,
    i {
      color: @shColor;
    }
  }
}
</style>
